module.exports = __webpack_public_path__ + "static/img/rotate_notice.e7bf5f35.png";